import { TextField, TextFieldProps } from '@mui/material'
import { ChangeEvent } from 'react'
import {
  decimalInputHtmlPattern,
  decimalInputPattern,
  integerInputHtmlPattern,
  integerInputPattern
} from 'utils/numericInputPatterns'

type NumericTextFieldProps = Omit<TextFieldProps, 'type'> & {
  allowDecimal?: boolean
}

export default function NumericTextField({
  allowDecimal = false,
  inputProps,
  onChange,
  ...textFieldProps
}: NumericTextFieldProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const pattern = allowDecimal ? decimalInputPattern : integerInputPattern

    if (pattern.test(event.target.value)) {
      onChange?.(event)
    }
  }

  return (
    <TextField
      {...textFieldProps}
      inputProps={{
        ...inputProps,
        inputMode: allowDecimal ? 'decimal' : 'numeric',
        pattern: allowDecimal ? decimalInputHtmlPattern : integerInputHtmlPattern
      }}
      onChange={handleChange}
      type='text'
    />
  )
}
